import { Controller } from "@hotwired/stimulus"
import chroma from "chroma-js";

export default class extends Controller {
  static targets = ["base", "accent1", "accent2", "accent3"];
  static outlets = ["color-picker"];

  connect() {
  }

  update() {
    let hex = this.baseTarget.value
    if (!hex) return
    if (!hex.startsWith("#")) hex = `#${hex}`

    const base = chroma(hex)

    // Work in LCH for more perceptual control
    let [L, C, H] = base.lch()

    // Normalize extreme lightness so super-dark/bright colors still behave
    if (L < 30) L = 30
    if (L > 80) L = 80

    // 1) Light – noticeably brighter, same chroma/saturation
    const light = chroma.lch(
      Math.min(L + 35, 95), // much lighter
      C,
      H
    )

    // 2) Light + desaturated – pastel / muted version
    const lightDesat = chroma.lch(
      Math.min(L + 30, 92), // lighter
      C * 0.25,             // strong desaturation
      H
    )

    // 3) Opposite light – complementary hue, still light
    const oppositeLight = chroma.lch(
      Math.min(L + 25, 90),
      C * 0.8,              // still colorful, not neon
      (H + 180) % 360       // 180° hue shift
    )

    const colors = [light.hex(), lightDesat.hex(), oppositeLight.hex()]

    // Ensure all colors have sufficient luminance for black text (minimum 0.5)
    const adjustedColors = colors.map(color => {
      const chromaColor = chroma(color)
      const luminance = chromaColor.luminance()

      // If the color is too dark for black text, lighten it to 0.65
      if (luminance < 0.5) {
        return chromaColor.luminance(0.65).hex()
      }
      return color
    })

    // Update each accent color if not locked
    this.updateAccent(this.accent1Target, adjustedColors[0], 0)
    this.updateAccent(this.accent2Target, adjustedColors[1], 1)
    this.updateAccent(this.accent3Target, adjustedColors[2], 2)
  }

  updateAccent(accentContainer, color, outletIndex) {
    const hexInput = accentContainer.querySelector('input[type="text"], input[type="hidden"][id*="hex"]')
    const lockCheckbox = accentContainer.querySelector('input[type="checkbox"]')

    if (lockCheckbox && lockCheckbox.checked) {
      return // Skip if locked
    }

    if (hexInput && color) {
      hexInput.value = color
    }

    // Update the color picker display
    const outlet = this.colorPickerOutlets[outletIndex]
    if (outlet && color) {
      outlet.setColor(color)
    }
  }
}
